import ViewQuiltOutlinedIcon from "@mui/icons-material/ViewQuiltOutlined";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { NOTIFICATION_TYPES, ACTIVITY_FEED_TYPES } from "../constants";

export const getAllTypes = () => {
    return { ...NOTIFICATION_TYPES, ...ACTIVITY_FEED_TYPES };
};

export const getTypeIcon = (type: string) => {
    const typeIcons = {
        [NOTIFICATION_TYPES.COMMENT]: <ViewQuiltOutlinedIcon />,
        [NOTIFICATION_TYPES.INSIGHT]: <RecordVoiceOverOutlinedIcon />,
        [NOTIFICATION_TYPES.EXPORT_TEAM_INTERVIEW]: <FileDownloadOutlinedIcon />,
        [ACTIVITY_FEED_TYPES.HYPOTHESIS]: <ViewQuiltOutlinedIcon />,
        [ACTIVITY_FEED_TYPES.HYPOTHESIS_STATE_CHANGE]: <ViewQuiltOutlinedIcon />,
        [ACTIVITY_FEED_TYPES.HYPOTHESIS_LINK]: <ViewQuiltOutlinedIcon />,
        [ACTIVITY_FEED_TYPES.ENTRY_CONTENT_CHANGE]: <ViewQuiltOutlinedIcon />,
        [ACTIVITY_FEED_TYPES.FINDING]: <RecordVoiceOverOutlinedIcon />,
        [ACTIVITY_FEED_TYPES.INTERVIEW]: <RecordVoiceOverOutlinedIcon />,
    };

    return typeIcons[type] || null;
};
